import { getQueryClient } from '@/providers/queryClient';
import type { CurrentUser } from '@/providers/session-provider/types';
import { USER_QUERY_KEY } from '@/providers/session-provider/use-current-user';
import type { BaseInstance, ModelName } from '@pigello/pigello-matrix';

function getPermsForConfig(modelName: ModelName) {
  const queryCache = getQueryClient().getQueryCache();
  const data = queryCache?.find<CurrentUser>({ queryKey: [USER_QUERY_KEY] })
    ?.state.data;
  if (!data) {
    return {
      overall: {
        canCreate: false,
        canUpdate: false,
        canView: false,
        canDelete: false,
      },
      fields: {},
    };
  }

  return data?.permissions?.[modelName];
}

export function getPerms<Instance extends BaseInstance = BaseInstance>(
  modelName?: ModelName
) {
  if (!modelName) {
    return {
      canView: false,
      canCreate: false,
      canUpdate: false,
      canDelete: false,
      canHandle: false,
      fields: {} as {
        [key in keyof Instance]?: {
          canView?: boolean;
          canHandle?: boolean;
        };
      },
    };
  }
  const allPerms = getPermsForConfig(modelName);

  return {
    ...allPerms?.overall,
    fields: allPerms?.fields as {
      [key in keyof Instance]: {
        canView: boolean;
        canHandle: boolean;
      };
    },
  };
}

export const structuralPerms = [];
